import { Input } from "@/components/shared/form";
import { useTranslations } from "next-intl";

interface AdditionalObjectProps {
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
}

const AdditionalObject = ({ ...props }: AdditionalObjectProps) => {
  const t = useTranslations("common");

  return (
    <div className="mt-3 flex flex-col gap-3">
      <div className="flex flex-col items-center gap-3 sm:flex-row">
        <Input name={props.street} label={`${t("street")}*`} />
        <Input name={props.houseNumber} label={`${t("houseNum")}*`} />
      </div>
      <div className="flex flex-col items-center gap-3 sm:flex-row">
        <Input name={props.postalCode} label={`${t("zip")}*`} />
        <Input name={props.city} label={`${t("city")}*`} />
      </div>
    </div>
  );
};

export default AdditionalObject;
